import React from "react";
import { webPlayerStore } from "@app/Screens/WebPlayer/store/webPlayerStore";
import { useTranslation } from "react-i18next";

/**
 * Информация об игре в хедере
 */
export const InfoGameSection = () => {
	const { t } = useTranslation();
	const gameConfig = webPlayerStore((state) => state.gameConfig);

	const gameTitle = t(`game.${gameConfig.GameSystemName}`);

	if (gameTitle === undefined) return null;

	return <div className="header-info">{gameTitle}</div>;
};
